import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Segment, Grid } from 'semantic-ui-react'
import {isValidArr} from '../utils';
import * as TYPES from '../types';

const renderImage = (path, pos=TYPES.Position.CENTER, size='small') => {
  if(!path){
      return null;
  } 
  if(pos === TYPES.Position.CENTER){
    return (<Image  style={Style.image} src={path} size={size} centered />);
  }
  return (<Image  style={Style.image} src={path} size={size} floated={pos} />);
}

const renderParagraphs = (prs, prgStyle, separator)=>{
  if(!isValidArr(prs)){
    return null; 
  }

  return prs.map(pr => {
    return pr ? (
      <Grid.Row><Segment style={{width: '100%', margin: 20}}>
          {pr.imgPos === TYPES.Position.LEFT && <Grid.Column width={5}>
            {renderImage(pr.image, pr.imgPos, pr.imgSize)}
          </Grid.Column>}
          <Grid.Column width={10}>
            <p style={{...Style.paragraph, ...prgStyle}}>{pr.title}</p>
            <p style={Style.text}>{pr.text}</p>
          </Grid.Column>
          {pr.imgPos === TYPES.Position.RIGHT && <Grid.Column width={5}>
            {renderImage(pr.image, pr.imgPos, pr.imgSize)}
          </Grid.Column>}
        </Segment></Grid.Row>          
    ) : (<p/>);
  });
}

class SimplePage extends Component {
    render() {
      const {paragraph, paragraphs, separator} = this.props;
      return (
        <Grid style={{...Style.main, ...this.props.style}}>
          {renderParagraphs(paragraphs, paragraph.style, separator)}
        </Grid>
      );
    }
}
SimplePage.PropTypes = {
    paragraphs: PropTypes.array,
};
  
const Style = {
    main: {
      height:'auto',
      background:'lightgray', 
      //marginTop:'-2px'
    },
    image: {
      //margin: '2%', 
    },
    paragraph: {
      //height:'100%',
      //width: 'auto',
      //background: "#40bf40",
      margin: '2%',
      
    },
    title: {
      width: 'auto',
      height: 'auto',
      color: '#e1e1a2',
      fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
      fontSize: '20px',
      fontWeight: '900',
//      margin: '2% 30%',
      marginTop: '10px',
      //background: config.website.header.background,//"#40bf40"
    },
    text: {
      //fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
      fontSize: '20px',
      fontWeight: '400',
      textAlign: 'left',
    },
  }
export default SimplePage


// WEBPACK FOOTER //
// ./src/components/SimplePage.js